import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { merchantTile as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    rebateOptions: {
      hideRebatePrefix: true,
      hideElevationCurrency: true,
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
